import { render, staticRenderFns } from "./AppointmentService.vue?vue&type=template&id=68331ca3&scoped=true"
import script from "./AppointmentService.vue?vue&type=script&lang=ts"
export * from "./AppointmentService.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentService.vue?vue&type=style&index=0&id=68331ca3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68331ca3",
  null
  
)

export default component.exports